import {useContext} from "react";
import {AppContext} from "~/context/AppProvider";

/**
 * Quản trị viên = có root, hoặc 1 trong các cap quản trị (member_manage / permission).
 *
 * Lưu ý: caps chỉ nằm trong AppContext.permissions (không suy từ currentUser.role
 * ở Redux, cũng không dùng sub.is_root — đó là cờ phía billing).
 */
function useIsAdmin()
{
	const {permissions} = useContext(AppContext);

	if (!permissions) return false;

	return Boolean(permissions.root || permissions.member_manage === true || permissions.permission === true);
}

export default useIsAdmin;
